export const SKIPPED_REASON_LABEL: Record<string, string> = {
  not_music_event: "Page is not a music event",
  no_extractable_events: "No events could be extracted",
  no_extractable_screenings: "No screenings could be extracted",
  no_extractable_performances: "No performances could be extracted",
  instagram_not_event: "Instagram post is not an event",
  instagram_low_classification_confidence:
    "Instagram classification confidence too low",
  no_structured_name_date: "Missing structured event name or date",
  unparseable_date: "Event date could not be parsed",
  movie_already_exists: "Movie already exists in the Mood DB",
  no_selected_credits: "No credits were selected for resolution",
  credit_not_object: "Credit entry was malformed",
  missing_tmdb_person_id: "Credit is missing a TMDB person id",
  missing_name: "Credit is missing a name",
  screening_in_past: "Screening is in the past",
  play_already_exists: "Play already exists in the Mood DB",
  play_materialization_not_required: "Play materialization was not required",
  performance_in_past: "Performance is in the past",
  event_in_past: "Event is in the past",
  past_jsonld_date: "JSON-LD date is in the past",
  empty_lineup: "Lineup was empty",
  primary_skipped: "Stopped because the primary instance was skipped",
  primary_hitl: "Stopped because the primary instance needs manual review",
  primary_failed: "Stopped because the primary instance failed",
  primary_cancelled: "Stopped because the primary instance was cancelled",
  primary_duplicate: "Stopped because the primary instance was a duplicate",
  // The three codes the enrichment stages emit. Without
  // these `SkippedPanel` rendered the raw code, and `enrichment_already_fresh`
  // in particular read as a failure when it is the healthy path.
  enrichment_entity_missing:
    "Entity was deleted before the job ran — nothing left to enrich",
  enrichment_embed_not_requested:
    "Embedding was not requested for this job (mode was enrich-only)",
  enrichment_already_fresh:
    "Already enriched and embedded before this job was claimed — nothing to redo",
};

export function describeSkippedReason(code: string | null): string {
  if (!code) return "No reason provided";
  return SKIPPED_REASON_LABEL[code] ?? code;
}

/**
 * Skips that are the pipeline working correctly, not a gap to investigate.
 *
 * `skipped` is otherwise a "something stopped this" status, and `SkippedPanel`'s
 * chrome says so. Two of the three enrichment codes are the opposite:
 * `enrichment_already_fresh` is the fresh-create short-circuit — the tail had
 * already enriched the entity by the time the backend's create-trigger job was
 * claimed, which is a known and expected redundancy — and
 * `enrichment_embed_not_requested` records that a `mode=enrich` job correctly
 * declined to pay for a vector nobody asked for, with the *event* still ending
 * `enriched`. `enrichment_entity_missing` is deliberately NOT here: graceful,
 * but it means an entity vanished, which is worth a curator's attention.
 */
export const EXPECTED_SKIPPED_REASONS: ReadonlySet<string> = new Set([
  "enrichment_already_fresh",
  "enrichment_embed_not_requested",
]);

export function isExpectedSkip(code: string | null): boolean {
  return code !== null && EXPECTED_SKIPPED_REASONS.has(code);
}
